export default __webpack_public_path__ + "953d89366088258bd4e2e69d4e0fc787.svg";